import {
  Component,
  EventEmitter,
  Injector,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { MeddraNode } from '../../../ui/Node/MeddraNode/MeddraNode';
import { FormlyView } from '../../../ui/Data/FormlyView';
import { ListView } from '../../../ui/Data/ListView';
import { TreeNodeMeddraLevel } from '../../../ui/Node/MeddraNode/ListEntity/TreeNodeMeddraLevel';
import { ItemFinderComponent } from '../../item-finder/item-finder.component';
import { MeddraService } from '../../../service/meddra-service/meddra.service';
import { MedicinalproductsService } from '../../../service/medicinalproducts-service/medicinalproducts.service';
import { FormlyDetailedViewComponent } from '../../formly-detailed-view/formly-detailed-view.component';
import { MedicinalProductsListView } from '../../../ui/Data/MedicinalProductData/MedicinalProductsListView';
import { QueryConditionsNode } from '../../../ui/Node/QueryConditionsNode';
import { QueryResultNode } from '../../../ui/Node/QueryResultNode';
import { SimpleSearchListNode } from '../../../ui/Node/SimpleSearchListNode';
import { ResultList } from '../../../ui/Node/ListEntity/ResultList';

@Component({
  selector: 'app-detailed-meddra-view',
  templateUrl: './detailed-meddra-view.component.html',
  styleUrl: './detailed-meddra-view.component.scss',
})
export class DetailedMeddraViewComponent {
  constructor(private injector: Injector) {
    this.injector
      .get(MeddraService)
      .loading.subscribe((value) => (this.loading = value));
  }

  @Input() selectedNode: any;
  @Output() modelChange = new EventEmitter<any>();
  @Output() selectedNodeChange = new EventEmitter<any>();
  @Output() buttonAction = new EventEmitter<any>();
  @Output() removeNode = new EventEmitter<any>();
  @ViewChild('item_finder_component')
  item_finder_component!: ItemFinderComponent;
  @ViewChild('formly_detailed_view_component')
  formly_detailed_view_component!: FormlyDetailedViewComponent;

  loading: boolean = false;

  onFormlyDetailedModelChange(event: any) {
    this.modelChange.emit(event);
  }

  onListDetailedModelChange(event: any) {
    this.modelChange.emit(event);
  }

  onButtonAction(event: any) {
    if (event.action == 'refreshMeddra') {
      this.item_finder_component.item_finder_search_component.refresh(
        MeddraService
      );
    } else {
      this.buttonAction.emit(event);
    }
  }

  onSelectedNodeChange(selectedNode: MeddraNode) {
    this.selectedNodeChange.emit(selectedNode);
  }

  onRemoveNode(selectedNode: MeddraNode) {
    this.removeNode.emit(selectedNode);
  }

  isInstanceOfFormlyView(): boolean {
    return this.selectedNode.data instanceof FormlyView;
  }

  isInstanceOfListView(): boolean {
    return (
      this.selectedNode.data instanceof ListView ||
      this.selectedNode instanceof ResultList
    );
  }

  isQueryNode() {
    return (
      this.selectedNode instanceof QueryResultNode ||
      this.selectedNode instanceof QueryConditionsNode
    );
  }

  isQueryListView(): boolean {
    return (
      this.selectedNode instanceof QueryResultNode ||
      this.selectedNode.data instanceof MedicinalProductsListView ||
      this.selectedNode instanceof SimpleSearchListNode ||
      this.selectedNode instanceof TreeNodeMeddraLevel ||
      (this.selectedNode instanceof MeddraNode && !(this.selectedNode.data instanceof FormlyView))
    );
  }
}
